/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {DraftPageData, KTSVG} from '../../../../_metronic/helpers'

type Props = {
  className: string
}

const DraftPage: React.FC<Props> = ({className}) => {
  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5 ms-3'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-2 mb-1'>Draft</span>
          <span className='text-muted mt-1 fw-bold fs-7'>ordered by the most recent</span>
        </h3>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-400 text-muted'>
                <th className='ps-4 min-w-125px'>TYPE</th>
                <th className='min-w-125px'>NAME</th>
                <th className='min-w-125px'>CREATED</th>
                <th className='min-w-250px'>CONTENT</th>
                <th className='min-w-150px text-end'>ACTIONS</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {DraftPageData?.map((data: any, idx: number) => (
                <tr key={idx}>
                  <td className='ps-3'>
                    <a
                      //   href='#'
                      className={
                        data?.type === 'MMS'
                          ? 'badge badge-light-success badge-square p-4 w-50px h-50px'
                          : 'badge badge-light-info fs-7 badge-square p-4 w-50px h-50px'
                      }
                    >
                      {data?.type}
                    </a>
                  </td>
                  <td>
                    <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.name}</span>
                    <span className='text-gray-400'>{data?.nameSub}</span>
                  </td>
                  <td>
                    <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.createdAt}</span>
                  </td>
                  <td>
                    <span className='text-dark fw-400  d-block mb-1 fs-6'>{data?.content}</span>
                  </td>
                  <td className='ms-2 text-end'>
                    <button className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2'>
                      <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-2' />
                    </button>
                    <button className='btn btn-sm btn-icon btn-light btn-active-light-primary'>
                      <KTSVG
                        className='svg-icon-2'
                        path='/media/icons/duotune/general/gen027.svg'
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export {DraftPage}
